import {
  IDeltaHedgeExeCommonSearchParam,
  IIncrementalReport,
} from "../../../Interfaces/deltaHedgeExe";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getExeDecrementalTable } from "../../../Requests/deltaHedgeExe";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const DeltaHedgeExeDecremental = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IIncrementalReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} AdditionalBody={Additional} />
      )}
      getDataTable={getExeDecrementalTable}
      searchParameters={searchParams}
    />
  );
};
export default DeltaHedgeExeDecremental;
